import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const MeterIcon: React.FC<ColorIconProps & React.SVGProps<SVGSVGElement>> = ({
  size = "default",
  className,
  ...props
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0403 2.29289C14.4308 2.68342 14.4308 3.31658 14.0403 3.70711L6.70694 11.0404C6.31642 11.431 5.68325 11.431 5.29273 11.0404L1.9594 7.70711C1.56887 7.31658 1.56887 6.68342 1.9594 6.29289C2.34992 5.90237 2.98309 5.90237 3.37361 6.29289L5.99984 8.91912L12.6261 2.29289C13.0166 1.90237 13.6498 1.90237 14.0403 2.29289Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7072 9.29297L17.7072 16.293C18.0977 16.6835 18.0977 17.3167 17.7072 17.7072C17.3167 18.0977 16.6835 18.0977 16.293 17.7072L9.29297 10.7072L10.7072 9.29297Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071C7.90237 17.3166 7.90237 16.6834 8.29289 16.2929L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289Z"
        fill="var(--cdl-chart-red-base)"
      />
    </svg>
  );
};

export default MeterIcon;
